export { ConsultationViewerModule } from './consultation-viewer.module';
export { FilePipe } from './file.pipe';
